module.exports = __webpack_public_path__ + "img/stock2.1853d644.png";